import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76d8842b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caption" }

import { PropType, computed } from 'vue'
import { LayoutInfoIcon } from '@/models/initData/LayoutInfo'


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: Object as PropType<LayoutInfoIcon>,
    require: true,
  },
  active: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props


const style = computed(() => {
  let imageUrl = `/images/icon/${props.icon?.icon}.svg`

  return {
    'background-image': `url('${imageUrl}')`,
  }
})
const itemClass = computed(() => {
  const icon = props.icon?.icon || ''

  return {
    'icon-active': props.active,
    'has-caption': !!props.icon?.caption,
    [icon]: true,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(style)),
    class: _normalizeClass(["item", _unref(itemClass)])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.icon?.caption), 1)
  ], 6))
}
}

})